export enum AuthType {
	VERIFY_OLD_MOBILE,
	VERIFY_NEW_MOBILE,
	LOGIN,
	DELETE_ACCOUNT,
	DELETE_ACCOUNT_HAS_ADS,
}
